var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgNoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4962,
    cy: 28.5523,
    r: 27.7247,
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0733 31.0727C38.0733 31.6074 37.8609 32.1203 37.4828 32.4984C37.1046 32.8766 36.5918 33.089 36.057 33.089H23.959L19.9263 37.1217V20.991C19.9263 20.4562 20.1387 19.9433 20.5168 19.5652C20.895 19.187 21.4078 18.9746 21.9426 18.9746H36.057C36.5918 18.9746 37.1046 19.187 37.4828 19.5652C37.8609 19.9433 38.0733 20.4562 38.0733 20.991V31.0727Z",
    stroke: "black",
    strokeWidth: 2.01634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgNoImg);
export default __webpack_public_path__ + "static/media/msg-no-img.b2ab4a2d84cf648306a991ba9c5cc371.svg";
export { ForwardRef as ReactComponent };